export default "__VITE_ASSET__BHI$HUMU__"